import React from 'react'
import Routes from './Routes'
import { AuthProvider } from '@dexter-experts/auth-react'
import '@dexter-experts/auth-react/styles.css'
import './App.css'

const authApiUrl = (process.env.REACT_APP_GRAPHQL_BASE_URL || '').replace(/\/graphql\/?$/, '')

const App = () => (
    <AuthProvider
        apiUrl={authApiUrl}
        loginRedirectTo="/"
        logoutRedirectTo={window.location.origin}
    >
        <Routes />
    </AuthProvider>
)

export default App
